// extracted by mini-css-extract-plugin
export default {"container":"Curve3_container__L27SU","curve":"Curve3_curve__oMq4H","white_curve":"Curve3_white_curve__-IHE1","inner_container":"Curve3_inner_container__vsfah"};